import React from 'react';
import ProviderCardProfileImage from './ProviderCardProfileImage';
import ProviderCardHeader from './ProviderCardHeader';
import ProviderCardName from './ProviderCardName';
import { ProviderCardProps } from './ProviderCardTypes';
import { Colors } from 'library';
import ProviderCardMobileIconActions from './ProviderCardMobileIconActions';

const BaseMobileProviderCard = ({
    provider,
    details,
    actions,
    onGoToProfile,
    jobId,
    header = <ProviderCardHeader provider={provider} mobile />,
    name = <ProviderCardName provider={provider} mobile jobId={jobId} />,
}: ProviderCardProps) => {
    const leftSide = () => (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                width: 140,
                height: '100%',
                backgroundColor: Colors.lightTurq,
                borderTopLeftRadius: 15,
                borderBottomLeftRadius: 15,
                alignItems: 'space-between',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    padding: 20,
                }}
            >
                <ProviderCardProfileImage provider={provider} mobile onGoToProfileClick={onGoToProfile} jobId={jobId} />
                <div style={{ marginTop: 12 }}>{header}</div>
            </div>
            <ProviderCardMobileIconActions provider={provider} />
        </div>
    );

    const rightSide = () => (
        <div
            style={{
                display: 'flex',
                flexGrow: 1,
                flexDirection: 'column',
                justifyContent: 'space-between',
                margin: 10,
                width: '50%',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                }}
            >
                {name}
                {details}
            </div>
            {actions}
        </div>
    );

    return (
        <>
            {leftSide()}
            {rightSide()}
        </>
    );
};

export default BaseMobileProviderCard;
